<div class="response table-responsive m-b-2">
    <table class="est-table building-table" cellspacing="0">
        <thead>
            <tr>
                <th>Property Uid</th>
                <th>Property Name</th>
                <th>Neigh Name</th>
                <th>Block Name</th>
                <th>Parcel No</th>
                <th>Paci No</th>
                <th>Parcel Uid</th>
                <th>Distance (m)</th>
                <th>Property Category</th>
                <th>Latitude</th>
                <th>Longitude</th>
            </tr>
        </thead>
        <tbody>
            @for (item of response; track $index) {
            <tr>
                <td>{{item?.property_uid || '-'}}</td>
                <td>{{item?.property_name || '-'}}</td>
                <td>{{item?.neigh_name || '-'}}</td>
                <td>{{item?.block_name || '-'}}</td>
                <td>{{item?.parcel_no || '-'}}</td>
                <td>{{item?.paci_no || '-'}}</td>
                <td>{{item?.parcel_uid || '-'}}</td>
                <td>{{item?.distance  ? (item?.distance | number : '1.0-2') : '-'}}</td>
                <td>{{item?.property_category || '-'}}</td>
                <td>{{item?.lat || '-'}}</td>
                <td>{{item?.lon || '-'}}</td>
            </tr>
            }
        </tbody>
    </table>
</div>